/* =============================================================
   Sensovyu Product Page — hero gallery, purchase options,
   and the smooth accordion pushdown.
   Loaded once by sou-product-hero.liquid.
   ============================================================= */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.souInit === '1') return;
    root.dataset.souInit = '1';

    /* ── Gallery carousel ───────────────────────────────── */
    var gal = root.querySelector('[data-gallery]');
    if (gal) {
      var slides = gal.querySelectorAll('.sou-gallery-slide');
      var dots = gal.querySelectorAll('[data-gallery-dot]');
      if (slides.length > 1) {
        var idx = 0;
        var show = function (i) {
          idx = (i + slides.length) % slides.length;
          slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
          dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
        };
        var prev = gal.querySelector('[data-gallery-prev]');
        var next = gal.querySelector('[data-gallery-next]');
        if (prev) prev.addEventListener('click', function () { show(idx - 1); });
        if (next) next.addEventListener('click', function () { show(idx + 1); });
        dots.forEach(function (d) {
          d.addEventListener('click', function () {
            show(parseInt(d.getAttribute('data-gallery-dot'), 10));
          });
        });

        /* Swipe to advance. A third caller of show(), so the arrows, the
           dots and the swipe all move the same carousel.

           Pointer events rather than touch events: one path covers finger
           and stylus, and it does not interfere with the arrow buttons.
           Mouse is deliberately excluded so desktop behaves exactly as
           before.

           Vertical scrolling has to win. Two things protect it: the
           gesture is ignored unless horizontal travel beats vertical, and
           the browser fires pointercancel the moment it decides the
           gesture is a page scroll, which drops the tracking. The CSS
           also sets touch-action:pan-y so the scroller never has to
           compete with this handler. */
        var THRESHOLD = 40;
        var sx = 0, sy = 0, tracking = false;

        gal.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse') return;
          tracking = true;
          sx = e.clientX;
          sy = e.clientY;
        }, { passive: true });

        gal.addEventListener('pointerup', function (e) {
          if (!tracking) return;
          tracking = false;
          var dx = e.clientX - sx;
          var dy = e.clientY - sy;
          if (Math.abs(dx) < THRESHOLD) return;
          if (Math.abs(dx) <= Math.abs(dy)) return;
          show(dx < 0 ? idx + 1 : idx - 1);
        }, { passive: true });

        gal.addEventListener('pointercancel', function () { tracking = false; }, { passive: true });
      }
    }

    /* ── Purchase options ────────────────────────────────
       A disabled input is not submitted, so the hidden
       selling_plan field is simply switched on and off. The
       markup ships in the state matching the checked radio,
       so this still works if the script never runs. */
    var planField = root.querySelector('[data-selling-plan-field]');
    var priceDisplay = root.querySelector('[data-price-display]');
    root.querySelectorAll('[data-purchase-option]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (planField) planField.disabled = radio.value !== 'subscription';
        // The large price follows the chosen option.
        var p = radio.getAttribute('data-price');
        if (priceDisplay && p) priceDisplay.innerHTML = p;
      });
    });

    /* ── Accordion ───────────────────────────────────────
       Animating the panel's height grows the hero row — and
       with it the image opposite — instead of snapping.
       Web Animations gives a handle that can be cancelled, so
       a fast second click can't leave a stale listener behind
       that clears the height mid-flight. */
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canAnimate = typeof Element !== 'undefined' && Element.prototype.animate;
    if (reduce || !canAnimate) return; // native snap-open is the fallback

    var OPEN = { duration: 460, easing: 'cubic-bezier(.22,.61,.36,1)' };
    var CLOSE = { duration: 380, easing: 'cubic-bezier(.4,0,.2,1)' };

    root.querySelectorAll('.sou-acc details').forEach(function (d) {
      var summary = d.querySelector('summary');
      var body = d.querySelector('.sou-acc__body');
      if (!summary || !body) return;
      var run = null;

      function play(from, to, opts, after) {
        if (run) run.cancel();
        body.style.height = to + 'px';
        run = body.animate([{ height: from + 'px' }, { height: to + 'px' }], opts);
        run.onfinish = function () {
          run = null;
          body.style.height = '';
          if (after) after();
        };
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (!d.open) {
          d.open = true; // render it so it can be measured
          play(0, body.scrollHeight, OPEN);
        } else {
          play(body.getBoundingClientRect().height, 0, CLOSE, function () { d.open = false; });
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-section-type="sou-product-hero"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders a section without a full page load
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-section-type="sou-product-hero"]');
    if (el) init(el);
  });
})();
